/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ValidateDeliveryDistanceReason = {
    tooFar: 'tooFar',
    deliveryNotOffered: 'deliveryNotOffered',
    googleApiError: 'googleApiError'
} as const;
export type ValidateDeliveryDistanceReason = typeof ValidateDeliveryDistanceReason[keyof typeof ValidateDeliveryDistanceReason];


export function instanceOfValidateDeliveryDistanceReason(value: any): boolean {
    for (const key in ValidateDeliveryDistanceReason) {
        if (Object.prototype.hasOwnProperty.call(ValidateDeliveryDistanceReason, key)) {
            if (ValidateDeliveryDistanceReason[key as keyof typeof ValidateDeliveryDistanceReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ValidateDeliveryDistanceReasonFromJSON(json: any): ValidateDeliveryDistanceReason {
    return ValidateDeliveryDistanceReasonFromJSONTyped(json, false);
}

export function ValidateDeliveryDistanceReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateDeliveryDistanceReason {
    return json as ValidateDeliveryDistanceReason;
}

export function ValidateDeliveryDistanceReasonToJSON(value?: ValidateDeliveryDistanceReason | null): any {
    return value as any;
}

export function ValidateDeliveryDistanceReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): ValidateDeliveryDistanceReason {
    return value as ValidateDeliveryDistanceReason;
}

